// extracted by mini-css-extract-plugin
export default {"snackbar_wrapper":"Snackbar_snackbar_wrapper__qrlJg","success":"Snackbar_success__6L+iG","error":"Snackbar_error__lj9UL"};